import React, { useEffect, useState } from "react";
import { makeRequest } from "../services/api";
import { webEndPoint, razorpayKey } from "../constants/globalConstants";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
export default function Checkout() {
    const navigate = useNavigate();
    const [cartData, setCartData] = useState({});
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [saveInfo, setSaveInfo] = useState(false);
    const [shippingMethod, setShippingMethod] = useState([]);
    const [shippingData, setShippingData] = useState([]);
    const [selectedCourier, setSelectedCourier] = useState(null);
    const [shippingCharges, setShippingCharges] = useState(0);
    const [discountValue, setDiscountValue] = useState(0);
    const [couponCode, setCouponCode] = useState("");
    const [stateCode, setStateCode] = useState(0);
    const [isSeller, setIsSeller] = useState(false);
    const [sellerName, setSellerName] = useState("");
    const [sellerMobile, setSellerMobile] = useState("");
    const [address, setAddress] = useState({ name: "", phone: "", address1: "", address2: "", city: "", pincode: "", landmark: "", district_id: "", state_id: "", email: "" });
    useEffect(() => {
        fetchAllData();
    }, []);
    const fetchAllData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStateData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            const res = await makeRequest("get", webEndPoint + "cart/" + localStorage.getItem("userID")
            );
            setCartData(res.data.cart);
            setItems(res.data.items);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
        try {
            const res = await makeRequest("get", webEndPoint + "user/" + localStorage.getItem("userID")
            );
            const u = res.data;
            setAddress({
                name: u.first_name,
                phone: u.mobile_number,
                address1: u.address_line1,
                address2: u.address_line2,
                city: u.city,
                pincode: u.pincode,
                state_id: u.state_id,
                district_id: u.district_id,
                landmark: u.landmark,
                email: u.email_id,
            });
            setStateCode(u.state_id);
            handleStateChange(u.state_id, u.district_id);
        } catch (err) {
            console.error(err);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "courier";
            const response = await makeRequest("get", url);
            if (response) {
                setShippingMethod(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "shipping-charges";
            const response = await makeRequest("get", url);
            if (response) {
                setShippingData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const subtotal = items.reduce((acc, item) => acc + Number(item.price) * item.quantity, 0) || 0;
    const total = subtotal + Number(shippingCharges) - Number(discountValue);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddress((prev) => ({ ...prev, [name]: value }));
    };
    const checkCurrentStock = async () => {
        setLoading(true);
        try {
            const updatedItems = await Promise.all(
                items?.map(async (item) => {
                    try {
                        let url = webEndPoint + `productAttributes/stock/${item.variant_id}`;
                        const response = await makeRequest("get", url);
                        const stock = response?.data?.retail_quantity || 0;
                        return { ...item, stock_available: stock >= item.quantity };
                    } catch (err) {
                        return { ...item, stock_available: false };
                    }
                })
            );
            return updatedItems;
        } catch (error) {
            console.error(error);
            return [];
        } finally {
            setLoading(false);
        }
    }

    const placeOrder = async () => {
        if (!localStorage.getItem("userID")) {
            toast.error("User not logged in");
            return;
        }
        if (!address?.state_id) {
            toast.error("State is required");
            return;
        }
        if (!address?.district_id) {
            toast.error("District is required");
            return;
        }
        if (!address?.address1) {
            toast.error("Address Line 1 is required");
            return;
        }
        if (!address?.address2) {
            toast.error("Address Line 2 is required");
            return;
        }
        if (!address?.city) {
            toast.error("City is required");
            return;
        }

        const pincodeRegex = /^[1-9][0-9]{5}$/;
        if (!address?.pincode || !pincodeRegex.test(address.pincode)) {
            toast.error("Enter valid 6-digit pincode");
            return;
        }
        if (shippingCharges === 0) {
            toast.error("Please select Shipping Method");
            return;
        }
        if (!cartData?.rfId) {
            toast.error("Cart is empty");
            return;
        }
        const stockItems = await checkCurrentStock();
        const outOfStockItems = stockItems.filter(
            (item) => Number(item.quantity) > Number(item.retail_quantity)
        );
        if (outOfStockItems.length > 0) {
            const productNames = outOfStockItems
                .map((item) => item.product_name)
                .join(", ");
            toast.error(
                `${productNames} is out of stock. Please remove that product and continue`
            );
            return;
        }
        if (!subtotal || subtotal <= 0) {
            toast.error("Invalid subtotal amount");
            return;
        }
        if (!total || total <= 0) {
            toast.error("Invalid final amount");
            return;
        }
        // const totalQty = items?.reduce((sum, item) => sum + item.quantity, 0);
        // if (totalQty < 2) {
        //     toast.error("Minimum 2 quantities required");
        //     return;
        // }
        const totalQty = items?.reduce((sum, item) => sum + item.quantity, 0);
        const isDefaultSize = items?.every(
            (item) => item.product_default_size_id === 1
        );
        if (!isDefaultSize && totalQty < 2) {
            toast.error("Minimum 2 quantities required");
            return;
        }
        if (isSeller) {
            if (!sellerName.trim()) {
                toast.error("Please enter Reseller Name");
                return;
            }
            const phoneRegex = /^[6-9]\d{9}$/;
            if (!phoneRegex.test(sellerMobile)) {
                toast.error("Please enter valid Reseller Mobile Number");
                return;
            }
        }
        await handleSaveAddress();
        setLoading(true);
        const qtyUpdate = {
            "user_id": localStorage.getItem("userID"),
            "user_name": address.name,
            "user_mobile": address.phone,
            "cart_id": cartData?.rfId,
            "total_amount": subtotal,
            "tax_amount": 0,
            "discount_amount": discountValue,
            "final_amount": total,
            "address_line1": address.address1,
            "address_line2": address.address2,
            "city": address.city,
            "district_id": address.district_id,
            "state_id": address.state_id,
            "pincode": address.pincode,
            "landmark": address.landmark,
            "payment_method": "Razorpay",
            "payment_status": "PENDING",
            "isSeller": isSeller ? 1 : 0,
            "seller_name": sellerName,
            "seller_mobile": sellerMobile,
            "shipping_charge": shippingCharges ? shippingCharges : 0,
            "courier_id": selectedCourier ? selectedCourier : 0
        }
        try {
            let url = webEndPoint + "checkout";
            const response = await makeRequest("post", url, qtyUpdate);
            if (response) {
                localStorage.setItem("userCheckoutID", response?.data?.rfId);
                handlePlaceOrder();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleStateChange = async (stateId, selectedDistrict = "") => {
        setStateCode(stateId);
        setLoading(true);
        setAddress((prev) => ({
            ...prev,
            state_id: stateId,
            district_id: selectedDistrict
        }));
        try {
            const url = webEndPoint + "districts/state/" + stateId;
            const res = await makeRequest("get", url);
            if (res) {
                setDistrictData(res.data);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setAddress((prev) => ({
            ...prev,
            district_id: districtId
        }));
    };
    const verifyPayment = async (data) => {
        setLoading(true);
        try {
            const payload = {
                razorpay_payment_id: data.razorpay_payment_id,
                razorpay_order_id: data.razorpay_order_id,
                razorpay_signature: data.razorpay_signature,
                checkout_id: localStorage.getItem("userCheckoutID"),
                user_id: localStorage.getItem("userID"),
                courier_id: selectedCourier,
                total_amount: subtotal,
                tax_amount: 0,
                discount_amount: discountValue,
                final_amount: total
            };
            const res = await makeRequest("post", webEndPoint + "payment/verify", payload);
            if (res?.success === true) {
                window.dispatchEvent(new Event("cartUpdated"));
                localStorage.removeItem("userCheckoutID");
                localStorage.setItem("orderNo", res?.order_id);
                toast.success("Order Placed Successfully");
                navigate("/orderstatus");
            } else {
                toast.error(res?.message || "Order creation failed");
            }
        } catch (err) {
            console.error(err);
            toast.error(err?.message);
        } finally {
            setLoading(false);
        }
    };
    const handlePlaceOrder = async () => {
        try {
            setLoading(true);
            const res = await makeRequest("post", webEndPoint + "payment/create-order",
                {
                    amount: total,
                    checkout_id: localStorage.getItem("userCheckoutID"),
                    user_id: localStorage.getItem("userID")
                }
            );
            if (!res?.success) {
                toast.error("Unable to create payment order");
                setLoading(false);
                return;
            }
            const order = res.order;
            const options = {
                key: razorpayKey,
                amount: order.amount,
                currency: order.currency,
                name: "Senthanamuthan Kids Wear Shop",
                description: "Order Payment",
                order_id: order.id,
                handler: async function (response) {
                    try {
                        setLoading(true);
                        await verifyPayment({
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature
                        });
                    } catch (err) {
                        console.log(err);
                        toast.error("Payment verification failed");
                    } finally {
                        setLoading(false);
                    }
                },
                modal: {
                    ondismiss: async function () {
                        try {
                            await makeRequest("put", webEndPoint + "payment/payment-failed", {
                                checkout_id: localStorage.getItem("userCheckoutID"),
                                payment_status: "CANCELLED"
                            }
                            );
                        } catch (err) {
                            console.log(err);
                        }
                        toast.error("Payment Cancelled");
                        setLoading(false);
                    }
                },
                prefill: {
                    name: address.name,
                    email: address.email,
                    contact: address.phone
                },
                config: {
                    display: {
                        blocks: {
                            cards: {
                                name: "Pay using Cards",
                                instruments: [
                                    {
                                        method: "card"
                                    }
                                ]
                            },
                            banks: {
                                name: "Netbanking",
                                instruments: [
                                    {
                                        method: "netbanking"
                                    }
                                ]
                            },
                            upi: {
                                name: "UPI",
                                instruments: [
                                    {
                                        method: "upi"
                                    }
                                ]
                            }
                        },
                        sequence: [
                            "block.cards",
                            "block.banks",
                            "block.wallets",
                            "block.upi"
                        ],
                        preferences: {
                            show_default_blocks: false
                        }
                    }
                },
                theme: {
                    color: "#e05da3"
                }
            };
            const rzp = new window.Razorpay(options);
            rzp.on("payment.failed",
                async function (response) {
                    console.log(response);
                    try {
                        await makeRequest("put", webEndPoint + "payment/payment-failed", {
                            checkout_id: localStorage.getItem("userCheckoutID"),
                            payment_status: "FAILED",
                            reason: response?.error?.description || ""
                        }
                        );
                    } catch (err) {
                        console.log(err);
                    }
                    toast.error(response?.error?.description || "Payment Failed");
                    setLoading(false);
                });
            rzp.open();
        } catch (err) {
            console.log(err);
            toast.error("Unable to initiate payment");
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    const handleAddNew = () => {
        setAddress({
            state_id: "",
            district_id: "",
            address1: "",
            address2: "",
            city: "",
            pincode: "",
            landmark: ""
        });
    };
    const handleSaveAddress = async () => {
        if (!address.name || address.name.trim() === "") {
            toast.error("Please enter Full Name");
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!address.email || !emailRegex.test(address.email)) {
            toast.error("Please enter valid Email Address");
            return;
        }
        const phoneRegex = /^[6-9]\d{9}$/;
        if (!address.phone || !phoneRegex.test(address.phone)) {
            toast.error("Please enter valid Mobile Number");
            return;
        }
        if (!address.address1 || address.address1.trim() === "") {
            toast.error("Please enter Address Line 1");
            return;
        }
        if (!address.city || address.city.trim() === "") {
            toast.error("Please enter City");
            return;
        }
        if (!address.state_id) {
            toast.error("Please select State");
            return;
        }
        if (!address.district_id) {
            toast.error("Please select District");
            return;
        }
        const pincodeRegex = /^[1-9][0-9]{5}$/;
        if (!address.pincode || !pincodeRegex.test(address.pincode)) {
            toast.error("Please enter valid Pincode");
            return;
        }
        try {
            setLoading(true);
            const payload = {
                first_name: address.name,
                email_id: address.email,
                mobile_number: address.phone,
                city: address.city,
                address_line1: address.address1,
                address_line2: address.address2,
                landmark: address.landmark,
                pincode: address.pincode,
                district_id: address.district_id ? Number(address.district_id) : null,
                state_id: address.state_id ? Number(address.state_id) : null,
            };
            const url = webEndPoint + "user/" + localStorage.getItem("userID");
            const response = await makeRequest("put", url, payload);
            if (response) {
                // toast.success("New Address updated successfully");
                fetchAllData();
            }
        } catch (err) {
            console.error(err);
            toast.error(err || "Update failed");
        } finally {
            setLoading(false);
        }
    }
    const totalQuantity = items?.reduce((sum, item) => sum + item.quantity, 0);
    useEffect(() => {
        if (!selectedCourier || !shippingData?.length) {
            setShippingCharges(0);
            return;
        }
        const courierSlabs = shippingData
            .filter(
                (s) =>
                    Number(s.courier_id) === Number(selectedCourier)
            )
            .sort(
                (a, b) =>
                    Number(a.number_of_pieces) -
                    Number(b.number_of_pieces)
            );
        const slab = courierSlabs.find(
            (item) =>
                Number(totalQuantity) <=
                Number(item.number_of_pieces)
        );
        const charge = slab
            ? Number(slab.charges)
            : Number(
                courierSlabs[courierSlabs.length - 1]?.charges || 0
            );
        setShippingCharges(charge);
    }, [selectedCourier, totalQuantity, shippingData]);

    const applyCoupon = async () => {
        if (!couponCode) {
            toast.error("Please Enter Valid Coupon Code");
            return;
        }
        try {
            setLoading(true);
            const payload = {
                coupon_code: couponCode,
                user_id: localStorage.getItem("userID"),
                subtotal: subtotal,
                cart_id: cartData?.rfId
            };
            const url = webEndPoint + "coupon/apply";
            const response = await makeRequest("post", url, payload);
            if (response) {
                toast.success("Coupon Code Applied successfully");
                setDiscountValue(response?.data?.discount)
            }
        } catch (err) {
            console.error(err);
            toast.error(err.message || "Update failed");
        } finally {
            setLoading(false);
        }
    }
    // const filteredShippingMethods = stateCode == 33 ? shippingMethod : shippingMethod?.filter((c) => c.rfId === 1);
    // useEffect(() => {
    //     if (!filteredShippingMethods?.length) return;
    //     // If current selected courier is not available, select first one
    //     const exists = filteredShippingMethods.some(
    //         c => c.rfId === selectedCourier
    //     );
    //     if (!exists) {
    //         setSelectedCourier(filteredShippingMethods[0].rfId);
    //     }
    // }, [stateCode, shippingMethod]);
    const filteredShippingMethods =
        stateCode == 33
            ? shippingMethod
            : shippingMethod?.filter((c) => c.rfId === 1);

    useEffect(() => {
        if (!filteredShippingMethods?.length) return;
        if (stateCode == 33) {
            // Default to ST Courier (rfId = 2) if available
            const stCourier = filteredShippingMethods.find(c => c.rfId === 2);
            if (stCourier) {
                setSelectedCourier(stCourier.rfId);
            } else {
                setSelectedCourier(filteredShippingMethods[0].rfId);
            }
        } else {
            // Default to India Post
            setSelectedCourier(filteredShippingMethods[0].rfId);
        }
    }, [stateCode, shippingMethod]);
    return (
        <div>
            <Loader loading={loading} />
            <Header />
            <Loader loading={loading} />
            <div className="checkout-page">
                <h2>Checkout</h2>
                <div className="checkout-section">
                    <button className="backhome-btn" onClick={() => navigate("/")}>Back to Home</button>
                    <br/><br/>
                    <div className="checkout-section">
                        <h3>Are you a Reseller?</h3>
                        <div className="reseller-options">
                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="isSeller"
                                    checked={!isSeller}
                                    onChange={() => { setIsSeller(false); setSellerName(""); setSellerMobile(""); }} />
                                <span>No</span>
                            </label>
                            <label className="radio-option">
                                <input
                                    type="radio"
                                    name="isSeller"
                                    checked={isSeller}
                                    onChange={() => {setIsSeller(true); }} />
                                <span> Yes</span>
                            </label>
                        </div>
                        {isSeller && (
                            <>
                                <div className="form-group">
                                    <label>Reseller Name</label>
                                    <input
                                        type="text"
                                        value={sellerName}
                                        onChange={(e) => setSellerName(e.target.value)}
                                        placeholder="Enter Reseller Name" />
                                </div>
                                <div className="form-group">
                                    <label>Reseller Mobile Number</label>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        value={sellerMobile}
                                        onChange={(e) => setSellerMobile(e.target.value.replace(/\D/g, ""))} placeholder="Enter Mobile Number" />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="address-header">
                        <h3>Delivery Address</h3>
                    </div>
                    <div className="address-actions">
                        <button type="button" className="default-btn" onClick={() => { fetchAllData(); setIsAddingNew(false); setSaveInfo(false); }}>Default Address</button>
                        <button type="button" className="add-btn" onClick={() => { handleAddNew(); setIsAddingNew(true); }}>Add New Address</button>
                    </div>
                    <div className="form-group">
                        <label>{isSeller ? 'Custome Name' : 'Name'}</label>
                        <input name="name" value={address.name} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>{isSeller ? 'Custome Phone' : 'Phone'}</label>
                        <input name="phone" value={address.phone} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input name="email" value={address.email} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>State</label>
                        <select name="state_id" value={address.state_id} onChange={(e) => handleStateChange(e.target.value)}>
                            <option value="">Select State</option>
                            {stateData?.map((s) => (
                                <option key={s.rfId} value={s.rfId}>{s.state_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>District</label>
                        <select name="district_id" value={address.district_id || ""} disabled={!address.state_id} onChange={handleDistrictChange}>
                            <option value="">Select District</option>
                            {districtData?.map((d) => (
                                <option key={d.district_id} value={d.district_id}>{d.district_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Address Line 1</label>
                        <input name="address1" value={address.address1} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Address Line 2</label>
                        <input name="address2" value={address.address2} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>City</label>
                        <input name="city" value={address.city} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Pincode</label>
                        <input name="pincode" value={address.pincode} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Landmark</label>
                        <input name="landmark" value={address.landmark} onChange={handleChange} />
                    </div>
                    <div className="form-checkbox">
                        <input type="checkbox" id="saveInfo" checked={saveInfo} onChange={(e) => setSaveInfo(e.target.checked)} />
                        <label htmlFor="saveInfo">
                            Save this information for next time
                        </label>
                    </div>
                    {isAddingNew && (
                        <button className="save-address-btn" onClick={handleSaveAddress}>
                            Save New Address
                        </button>
                    )}
                </div>

                <div className="checkout-section">
                    <h3>Order Summary</h3>
                    {items?.map((item) => (
                        <div key={item.cart_item_id} className="checkout-item">
                            <img src={item.color_image_url} width={60} />
                            <div>
                                <p>{item?.product_name}</p>
                                <p>Color : {item?.color_name}</p>
                                <p>Variant : {item.size_name ? item.size_name : item.age_name}</p>
                                <p>{item?.product_name}</p>
                                <p>Quantity: {item?.quantity}</p>
                            </div>
                            <div>₹{item.price}</div>
                        </div>
                    ))}
                </div>
                <div className="checkout-section">
                    <h3>Price Details</h3>
                    <div className="price-row">
                        <span>Subtotal (Inclusive of All Tax)</span>
                        <span>₹{subtotal}</span>
                    </div>
                    <h4 style={{ marginTop: "10px" }}>Shipping Method</h4>
                    <div className="shipping-box">
                        {/* {shippingMethod?.map((c) => (
                            <label key={c.rfId} className={`shipping-item ${selectedCourier === c.rfId ? "active" : ""}`}>
                                <input
                                    type="radio"
                                    name="shipping"
                                    value={c.rfId}
                                    checked={selectedCourier === c.rfId}
                                    onChange={(e) => setSelectedCourier(Number(e.target.value))} />
                                <div className="shipping-content">
                                    <span className="courier-name">{c.courier_name}</span>
                                </div>
                            </label>
                        ))} */}
                        {filteredShippingMethods?.map((c) => (
                            <label
                                key={c.rfId}
                                className={`shipping-item ${selectedCourier === c.rfId ? "active" : ""}`}
                            >
                                <input
                                    type="radio"
                                    name="shipping"
                                    value={c.rfId}
                                    checked={selectedCourier === c.rfId}
                                    onChange={(e) => setSelectedCourier(Number(e.target.value))}
                                />
                                <div className="shipping-content">
                                    <span className="courier-name">{c.courier_name}</span>
                                </div>
                            </label>
                        ))}
                    </div>
                    <div className="price-row">
                        <span>Total Pieces</span>
                        <span>{totalQuantity}</span>
                    </div>
                    <div className="price-row">
                        <span>Shipping Charges </span>
                        <span>₹{shippingCharges}</span>
                    </div>
                    <h4 style={{ marginTop: "10px" }}>Apply Discount Code</h4>
                    <div className="coupon-box">
                        <input type="text" placeholder="Enter discount code" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
                        <button onClick={() => applyCoupon(couponCode)}>Apply</button>
                        <span>₹{discountValue}</span>
                    </div>
                    <hr />
                    <div className="price-row total">
                        <span>Total</span>
                        <span>₹{total}</span>
                    </div>
                </div>
                <button className="checkout-btn" onClick={() => placeOrder()} disabled={loading}>
                    {loading ? "Placing..." : "Place Order"}
                </button>
                <h4>Note : Please don't press the back button until you get the order id If you have not received an order id Please WhatsApp 9360990836</h4>
                <h4>குறிப்பு : உங்களுக்கு ஆர்டர் ஐடி கிடைக்கும் வரை தயவுசெய்து Back பொத்தானை அழுத்த வேண்டாம். உங்களுக்கு ஆர்டர் ஐடி கிடைக்கவில்லை என்றால், தயவுசெய்து 9360990836 என்ற எண்ணுக்கு வாட்ஸ்அப் செய்யவும்.</h4>
            </div>
            <Footer />
        </div>
    );
}